// extracted by mini-css-extract-plugin
module.exports = {"button":"SuggestedButtons_button__kYNDQ","close-icon":"SuggestedButtons_close-icon__Ofho2","disabled":"SuggestedButtons_disabled__GEIRE"};